// extracted by mini-css-extract-plugin
module.exports = {"root":"topbar-lgpd_root__2z4dR","show":"topbar-lgpd_show___eto8","content":"topbar-lgpd_content__vCB7g","title":"topbar-lgpd_title__OAIx7"};